<template>
    <transition name="slide-fade">

        <div class="idea-detail flex h-full w-full flex-col" v-if="show">
            <Header
                :total-list="totalList"
                :current-index="currentIndex"
                :detail-basic-info="detailBasicInfo"
                :next-disabled="nextDisabled"
                :prev-disabled="prevDisabled"
                @click:handelNext="handleNext"
                @click:handelPrev="handlePrev"
                @click:handelToResult="handleResult"
                @click:handelAddToReport="addIntoReport"/>

            <div class="flex h-10 w-full shrink-0 items-center justify-between bg-grey-20  pl-2 pr-3">

                <div class="th-tabs th-tabs-plain-lifted pt-1">
                    <a
                        v-for="tab in tabConfig.tabs"
                        :key="tab.name"
                        :class="{ 'th-tab-plain-lifted-active': tab.name === tabConfig.currTab }"
                        class="th-tab th-tab-plain-lifted"
                        @click="()=>handelClickTab(tab.name)">
                        {{tab.label}}</a>
                </div>

                <Translate />
            </div>

            <RouterView class="light-scroll h-full grow overflow-y-auto" :detail-basic-info="detailBasicInfo" :translateMode="transLang" :inputLang="inputLang" :editContent="editContent"/>
        </div>
    </transition>

</template>

<script setup lang="ts">
import { useDetail } from './use-detail';
import Header from '@/components/detail/Header.vue'
import Translate from '@/components/detail/Translate.vue'
import { useGlobalState } from '@/composables/use-global-store';

const {
    show,
    totalList,
    currentIndex,
    tabConfig,
    handleNext,
    handlePrev,
    handleResult,
    detailBasicInfo,
    prevDisabled,
    nextDisabled,
    addIntoReport,
    handelClickTab,
} = useDetail();

const { transLang, inputLang, editContent } = useGlobalState();

</script>

<style lang="scss">
/*
  进入和离开动画可以使用不同
  持续时间和速度曲线。
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
